<app-tipo-documento-form
  [editar]="editar"
  [tipoDocumento]="tipoDocumento"
></app-tipo-documento-form>
